/** Create or update a feed. */
export const feedSaveSpec = {
    uri: '/t/[tenant]/feed/[feed]',
    method: 'PUT',
};
